module.exports = __webpack_public_path__ + "img/Gluten.da8415b5.svg";